import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useRef, useState } from "react";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { useUserInfor } from "../../../../Context/User";
import { CriarAgendamentoDeAtendimentoController } from "../../../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import {
    ListarTipoCompromissoController,
    ListarUsuariosAtivosComAcessoCasoController,
    ListarUsuariosAtivosComAcessoCasoVistoriaController,
    ListarUsuariosLembretesController,
} from "../../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import {
    ListarCompromissoDisponivelHorarioController,
    ListarUsuariosCompromissoDisponivelHorariosController,
} from "../../../../Controllers/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelController";
import {
    ListarDocumentoTemplatePorClassificacaoController,
    PreencherTemplateEmailClienteController,
} from "../../../../Controllers/Geral/Documentos/DocumentosController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IAgendamento } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { IAtendimento } from "../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import UnForm from "../../../Form";
import OrSpinner from "../../../Utils/OrSpinner";
import ModalComponent from "../../../Modais";
import { IComponentModal } from "../../../Modais/IModalComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AgendaModal from "./AgendaModal";
import { FroalaEditor } from "../../Forms/Editor/FroalaEditor";
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment";
import { ListarUnidadesPorEmpreendimentoController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";

interface ICriarAgendamentoProps {
    Atendimento?: IAtendimento;
    setShow: Dispatch<SetStateAction<boolean>>;

    updateList: () => void;
    ID_TIPO_COMPROMISSO?: number;
    idCaso?: number;

    setAtualizaAgenda?: Dispatch<SetStateAction<boolean>>;
}
interface htmlQuill {
    editorHtml: string;
}
export default function CriarAgendamento(props: ICriarAgendamentoProps) {
    const { id } = useModuloInfo();
    const { Config } = useUserInfor();
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";
    const { updateAtendimento, ID_CASO, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [data, setData] = useState("");
    const [usuario, setUsuario] = useState("");
    const [idTemplateEmail, setIdTemplateEmail] = useState(0);
    const [assunto, setAssunto] = useState(
        props.Atendimento?.DS_CATEGORIA_ATENDIMENTO ?? ""
    );
    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);
    const [mostrarCampos, setMostrarCampos] = useState(false);
    const FormMethods = useForm();
    const { watch } = FormMethods;
    const watcher = watch();
    const config = Config.ConfigAssistenciaTecnicaDTO;

    const [dtFimSelecionado, setDtFimSelecionado] = useState("");

    const [idUnidade, setIdUnidade] = useState(0);
    const [idTipoCompromisso, setIdTipoCompromisso] = useState(0);

    const { value: LstDocumentoTemplate } = useAsyncEffect(
        () =>
            ListarDocumentoTemplatePorClassificacaoController(id ?? 0, 6, true),
        [id]
    );
    // const divEmp = props.Atendimento?.DS_PRODUTO_COMP?.split("-", 1);
    const agendaWindowRef = useRef<Window>();

    const { execute: executarFormAgendamento, loading } = useAsyncCallback(
        CriarAgendamentoDeAtendimentoController
    );

    const { execute: listUsuariosLembretes } = useAsyncCallback(
        ListarUsuariosLembretesController
    );

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMostrarCampos(e.target.checked);
    };

    const {
        value: compromissoDisponivelHorario,
        loading: compromissoDisponivelHorarioLoading,
    } = useAsyncEffect(async () => {
        if (
            (emccampMode === ID_ORGANIZACAO ||
                (config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS &&
                    ACESSOS.ASSISTENCIA.ID_MODULO === id) ||
                (Config.ConfigVistoriaDTO
                    .FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA &&
                    ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id)) &&
            data &&
            props.Atendimento?.ID_PRODUTO &&
            usuario &&
            (ACESSOS.ASSISTENCIA.ID_MODULO === id || idTipoCompromisso !== 0)
        ) {
            return ListarCompromissoDisponivelHorarioController(
                data,
                props.Atendimento?.ID_PRODUTO,
                emccampMode === ID_ORGANIZACAO ||
                    (config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS &&
                        ACESSOS.ASSISTENCIA.ID_MODULO === id) ||
                    (Config.ConfigVistoriaDTO
                        .FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA &&
                        ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id)
                    ? Number(usuario)
                    : 0,
                ID_CASO,
                false,
                0,
                ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id
                    ? idTipoCompromisso
                    : 0
            );
        } else if (
            (emccampMode !== ID_ORGANIZACAO ||
                (!config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS &&
                    ACESSOS.ASSISTENCIA.ID_MODULO !== id) ||
                (!Config.ConfigVistoriaDTO
                    .FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA &&
                    ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO !== id)) &&
            data &&
            usuario &&
            props.Atendimento?.ID_PRODUTO &&
            (ACESSOS.ASSISTENCIA.ID_MODULO === id || idTipoCompromisso !== 0)
        ) {
            return ListarCompromissoDisponivelHorarioController(
                data,
                props.Atendimento?.ID_PRODUTO,
                id === ACESSOS.ASSISTENCIA.ID_MODULO ||
                    id === ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO
                    ? Number(usuario)
                    : 0,
                ID_CASO,
                true,
                idUnidade ? idUnidade : 0,
                ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id
                    ? idTipoCompromisso
                    : 0
            );
        }
    }, [
        data,
        props.Atendimento?.ID_PRODUTO,
        (emccampMode === ID_ORGANIZACAO ||
            (config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS &&
                ACESSOS.ASSISTENCIA.ID_MODULO === id) ||
            (Config.ConfigVistoriaDTO
                .FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA &&
                ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id)) &&
        id === ACESSOS.ASSISTENCIA.ID_MODULO
            ? usuario
            : null,
        usuario,
        idUnidade,
        ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id && idTipoCompromisso,
    ]);
    const {
        value: listarUsuariosDisponiveis,
        loading: listarUsuariosDisponiveisLoading,
    } = useAsyncEffect(async () => {
        if (
            (emccampMode === ID_ORGANIZACAO ||
                (config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS &&
                    ACESSOS.ASSISTENCIA.ID_MODULO === id) ||
                (Config.ConfigVistoriaDTO
                    .FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA &&
                    ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id)) &&
            data
        ) {
            setUsuario("");
            return ListarUsuariosCompromissoDisponivelHorariosController(
                data,
                props.Atendimento?.ID_PRODUTO ?? 0
            );
        }
    }, [data, props.Atendimento?.ID_PRODUTO]);

    const { execute: ListarUnidadesPorEmpreendimento } = useAsyncCallback(
        () =>
            ListarUnidadesPorEmpreendimentoController(
                props.Atendimento?.ID_PRODUTO ?? 0
            ),
        [data, props.Atendimento?.ID_PRODUTO]
    );

    const handleCriarAgendamentoFormSubmit = (formData: IAgendamento) => {
        if (id === ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO) {
            executarFormAgendamento(
                {
                    ...formData,
                    DS_HTML_EMAIL:
                        convertedText.editorHtml &&
                        convertedText.editorHtml.length > 0
                            ? convertedText.editorHtml
                            : undefined,
                    DS_DESCRICAO: "",
                    HR_INICIO: formData.HR_INICIO,
                    ID_CASO,
                    ID_PRODUTO: idUnidade ? idUnidade : Atendimento?.ID_PRODUTO,
                    NECESSIDADE_VIZINHO: {
                        DS_NOME: formData.NECESSIDADE_VIZINHO?.DS_NOME,
                        DS_UNIDADE_VIZINHO:
                            formData.NECESSIDADE_VIZINHO?.DS_UNIDADE_VIZINHO,
                        FL_VIZINHO: formData.NECESSIDADE_VIZINHO?.FL_VIZINHO,
                        NR_TELEFONE_VIZINHO:
                            formData.NECESSIDADE_VIZINHO?.NR_TELEFONE_VIZINHO,
                        ID_COMPROMISSO:
                            formData.NECESSIDADE_VIZINHO?.ID_COMPROMISSO,
                        ID_NECESSIDADE_VIZINHO:
                            formData.NECESSIDADE_VIZINHO
                                ?.ID_NECESSIDADE_VIZINHO,
                    },
                },
                1
            ).then(() => {
                updateAtendimento();
                ReloadHistorico();
                props.updateList();
                props.setShow(false);
                agendaWindowRef.current?.close();
            });
        } else if (props.ID_TIPO_COMPROMISSO === 3) {
            executarFormAgendamento({
                ...formData,
                DS_HTML_EMAIL:
                    convertedText.editorHtml &&
                    convertedText.editorHtml.length > 0
                        ? convertedText.editorHtml
                        : undefined,
                DS_DESCRICAO: "",
                HR_INICIO: formData.HR_INICIO,
                ID_TIPO_COMPROMISSO: formData.ID_TIPO_COMPROMISSO,
            }).then(() => {
                props.updateList();
                props.setAtualizaAgenda?.((prev) => !prev);
                props.setShow(false);
                agendaWindowRef.current?.close();
            });
        } else {
            executarFormAgendamento({
                ...formData,
                DS_HTML_EMAIL:
                    convertedText.editorHtml &&
                    convertedText.editorHtml.length > 0
                        ? convertedText.editorHtml
                        : undefined,
                DS_DESCRICAO: "",
                HR_INICIO: formData.HR_INICIO,
                HR_FIM: formData.HR_FIM
                    ? formData.HR_FIM
                    : dtFimSelecionado
                    ? moment(dtFimSelecionado).format("HH:mm")
                    : "00:00",
                ID_CASO,
            }).then(() => {
                updateAtendimento();
                ReloadHistorico();
                props.updateList();
                props.setShow(false);
                agendaWindowRef.current?.close();
            });
        }
    };

    function listarUsuarios() {
        if (id === ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO) {
            return ListarUsuariosAtivosComAcessoCasoVistoriaController;
        } else if (id === ACESSOS.ASSISTENCIA.ID_MODULO) {
            return ListarUsuariosAtivosComAcessoCasoController;
        } else {
            return listUsuariosLembretes;
        }
    }

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }
    return (
        <div>
            <FormProvider {...FormMethods}>
                <UnForm
                    handleSubmit={handleCriarAgendamentoFormSubmit}
                    usingContext
                >
                    {({ getValues, setValue }) => (
                        <>
                            <div className="mb-8">
                                <div className="row ">
                                    {emccampMode === ID_ORGANIZACAO ||
                                    (config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS &&
                                        ACESSOS.ASSISTENCIA.ID_MODULO === id) ||
                                    (Config.ConfigVistoriaDTO
                                        .FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA &&
                                        ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO ===
                                            id) ? (
                                        <>
                                            <UnForm.Input
                                                wrapperClassName="col-md-6 col-lg-4"
                                                label="Data"
                                                name="DT_CADASTRO"
                                                type={"date"}
                                                onBlur={(e) => {
                                                    setData(e.target.value);
                                                }}
                                                onChange={(e) => {
                                                    setUsuario("");

                                                    if (idTemplateEmail !== 0) {
                                                        PreencherTemplateEmailClienteController(
                                                            idTemplateEmail,
                                                            {
                                                                ...watcher,
                                                                ID_USUARIO:
                                                                    watcher.ID_USUARIO,
                                                                ID_CASO:
                                                                    ID_CASO,
                                                                HR_INICIO:
                                                                    watcher.HR_INICIO,
                                                            }
                                                        )
                                                            .then((res) => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            res,
                                                                    }
                                                                );
                                                            })
                                                            .catch(() => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            "Erro ao carregar template.",
                                                                    }
                                                                );
                                                            });
                                                    }
                                                }}
                                                registerOptions={{
                                                    required: "Insira a Data",
                                                }}
                                            />

                                            <UnForm.Select
                                                label="Atribuído a"
                                                name="ID_USUARIO"
                                                className={`form-control placeholder-dark-50`}
                                                wrapperClassName="col-md-6 col-lg-4"
                                                onChange={(e) => {
                                                    setUsuario(e.target.value);
                                                    if (idTemplateEmail !== 0) {
                                                        PreencherTemplateEmailClienteController(
                                                            idTemplateEmail,
                                                            {
                                                                ...watcher,
                                                                ID_USUARIO:
                                                                    watcher.ID_USUARIO,
                                                                ID_CASO:
                                                                    ID_CASO,
                                                                HR_INICIO:
                                                                    watcher.HR_INICIO,
                                                            }
                                                        )
                                                            .then((res) => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            res,
                                                                    }
                                                                );
                                                            })
                                                            .catch(() => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            "Erro ao carregar template.",
                                                                    }
                                                                );
                                                            });
                                                    }
                                                }}
                                            >
                                                <option></option>
                                                {listarUsuariosDisponiveis?.map(
                                                    (u) => (
                                                        <option
                                                            value={u.ID_USUARIO}
                                                            key={u.ID_USUARIO}
                                                            selected={
                                                                u.ID_USUARIO.toString() ===
                                                                usuario
                                                            }
                                                        >
                                                            {u.DS_NOME}
                                                        </option>
                                                    )
                                                )}
                                            </UnForm.Select>
                                            <UnForm.LazySelect
                                                label={"Unidade"}
                                                wrapperClassName="col-md-6 col-lg-4"
                                                name="ID_UNIDADE"
                                                registerOptions={{
                                                    valueAsNumber: true,
                                                }}
                                                controller={
                                                    ListarUnidadesPorEmpreendimento
                                                }
                                                getDS={(u) => u.DS_UNIDADE}
                                                getKeyValue={(u) =>
                                                    u.ID_UNIDADE
                                                }
                                                onChange={(e) =>
                                                    setIdUnidade(
                                                        Number(e.target.value)
                                                    )
                                                }
                                            >
                                                <option value={0}></option>
                                            </UnForm.LazySelect>
                                        </>
                                    ) : (
                                        <>
                                            <UnForm.LazySelect
                                                controller={listarUsuarios()}
                                                label="Atribuído a"
                                                name="ID_USUARIO"
                                                className={`form-control placeholder-dark-50`}
                                                wrapperClassName="col-md-6 col-lg-4"
                                                onChange={(e) => {
                                                    setUsuario(e.target.value);
                                                    if (idTemplateEmail !== 0) {
                                                        PreencherTemplateEmailClienteController(
                                                            idTemplateEmail,
                                                            {
                                                                ...watcher,
                                                                ID_USUARIO:
                                                                    watcher.ID_USUARIO,
                                                                ID_CASO:
                                                                    ID_CASO,
                                                                HR_INICIO:
                                                                    watcher.HR_INICIO,
                                                            }
                                                        )
                                                            .then((res) => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            res,
                                                                    }
                                                                );
                                                            })
                                                            .catch(() => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            "Erro ao carregar template.",
                                                                    }
                                                                );
                                                            });
                                                    }
                                                }}
                                                getDS={(p) => p.DS_NOME}
                                                getKeyValue={(p) =>
                                                    p.ID_USUARIO
                                                }
                                                registerOptions={{
                                                    required:
                                                        "Insira um Usuário",
                                                }}
                                            >
                                                <option></option>
                                            </UnForm.LazySelect>
                                            <UnForm.Input
                                                wrapperClassName="col-md-6 col-lg-4"
                                                label="Data"
                                                name="DT_CADASTRO"
                                                type={"date"}
                                                onBlur={(e) => {
                                                    setData(e.target.value);
                                                }}
                                                onChange={(e) => {
                                                    if (idTemplateEmail !== 0) {
                                                        PreencherTemplateEmailClienteController(
                                                            idTemplateEmail,
                                                            {
                                                                ...watcher,
                                                                ID_USUARIO:
                                                                    watcher.ID_USUARIO,
                                                                ID_CASO:
                                                                    ID_CASO,
                                                                HR_INICIO:
                                                                    watcher.HR_INICIO,
                                                            }
                                                        )
                                                            .then((res) => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            res,
                                                                    }
                                                                );
                                                            })
                                                            .catch(() => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            "Erro ao carregar template.",
                                                                    }
                                                                );
                                                            });
                                                    }
                                                }}
                                                registerOptions={{
                                                    required: "Insira a Data",
                                                }}
                                            />{" "}
                                        </>
                                    )}

                                    <UnForm.LazySelect
                                        wrapperClassName="col-md-6 col-lg-4"
                                        className="mb-4"
                                        label="Tipo Compromisso"
                                        name="ID_TIPO_COMPROMISSO"
                                        onChange={(e) =>
                                            setIdTipoCompromisso(
                                                Number(e.target.value)
                                            )
                                        }
                                        controller={
                                            ListarTipoCompromissoController
                                        }
                                        getKeyValue={(u) =>
                                            u.ID_TIPO_COMPROMISSO
                                        }
                                        getDS={(u) => u.DS_TIPO_COMPROMISSO}
                                    >
                                        <option></option>
                                    </UnForm.LazySelect>

                                    {emccampMode === ID_ORGANIZACAO ||
                                    (config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS &&
                                        ACESSOS.ASSISTENCIA.ID_MODULO === id) ||
                                    (Config.ConfigVistoriaDTO
                                        .FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA &&
                                        ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO ===
                                            id) ? (
                                        <OrSpinner
                                            spinner="capys"
                                            loading={
                                                compromissoDisponivelHorarioLoading ||
                                                listarUsuariosDisponiveisLoading
                                            }
                                        >
                                            <UnForm.Select
                                                label="Horário"
                                                name="HR_INICIO"
                                                className="col-12 "
                                                wrapperClassName="col-md-6 col-lg-4"
                                                registerOptions={{
                                                    required:
                                                        "Insira um horário",
                                                }}
                                                onChange={(e) => {
                                                    if (idTemplateEmail !== 0) {
                                                        PreencherTemplateEmailClienteController(
                                                            idTemplateEmail,
                                                            {
                                                                ...watcher,
                                                                ID_USUARIO:
                                                                    watcher.ID_USUARIO,
                                                                ID_CASO:
                                                                    ID_CASO,
                                                                HR_INICIO:
                                                                    watcher.HR_INICIO,
                                                            }
                                                        )
                                                            .then((res) => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            res,
                                                                    }
                                                                );
                                                            })
                                                            .catch(() => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            "Erro ao carregar template.",
                                                                    }
                                                                );
                                                            });
                                                    }

                                                    const horarioSelecionado =
                                                        compromissoDisponivelHorario?.find(
                                                            (item) =>
                                                                item.DS_HORARIO ===
                                                                e.target.value
                                                        );
                                                    if (horarioSelecionado) {
                                                        setDtFimSelecionado(
                                                            horarioSelecionado.DT_FIM
                                                        );
                                                    }
                                                }}
                                            >
                                                <option></option>

                                                {compromissoDisponivelHorario?.map(
                                                    (disponibilidade) => {
                                                        return (
                                                            disponibilidade.FL_ATIVO ===
                                                                true &&
                                                            disponibilidade.FL_AGENDADO ===
                                                                true && (
                                                                <option
                                                                    value={
                                                                        disponibilidade.DS_HORARIO
                                                                    }
                                                                >
                                                                    {
                                                                        disponibilidade.DS_HORARIO
                                                                    }
                                                                </option>
                                                            )
                                                        );
                                                    }
                                                )}
                                            </UnForm.Select>
                                        </OrSpinner>
                                    ) : (
                                        <>
                                            <UnForm.Input
                                                name="HR_INICIO"
                                                wrapperClassName="col-md-6 col-lg-4"
                                                label="Hora Inicial"
                                                type={"time"}
                                                registerOptions={{
                                                    required:
                                                        "Insira o Horário Inicial do Reparo",
                                                }}
                                                onChange={() => {
                                                    const hrInicio1 =
                                                        getValues(
                                                            "HR_INICIO"
                                                        ).split(":")[0];
                                                    const hrInicio2 =
                                                        getValues(
                                                            "HR_INICIO"
                                                        ).split(":")[1];

                                                    const minutosTotalInicio =
                                                        Number(hrInicio1 * 60) +
                                                        Number(hrInicio2) +
                                                        30;

                                                    const horas =
                                                        Math.floor(
                                                            minutosTotalInicio
                                                        ) / 60;
                                                    const minutos =
                                                        minutosTotalInicio % 60;

                                                    const horasTexto = `${
                                                        horas
                                                            .toString()
                                                            .split(".")[0]
                                                            .length < 2
                                                            ? "0" +
                                                              horas
                                                                  .toString()
                                                                  .split(".")[0]
                                                            : horas
                                                                  .toString()
                                                                  .split(".")[0]
                                                    }:${
                                                        minutos.toString()
                                                            .length < 2
                                                            ? "0" +
                                                              minutos.toString()
                                                            : minutos.toString()
                                                    }`;

                                                    if (idTemplateEmail !== 0) {
                                                        PreencherTemplateEmailClienteController(
                                                            idTemplateEmail,
                                                            {
                                                                ...watcher,
                                                                ID_USUARIO:
                                                                    watcher.ID_USUARIO,
                                                                ID_CASO:
                                                                    ID_CASO,
                                                                HR_INICIO:
                                                                    watcher.HR_INICIO,
                                                            }
                                                        )
                                                            .then((res) => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            res,
                                                                    }
                                                                );
                                                            })
                                                            .catch(() => {
                                                                setConvertedText(
                                                                    {
                                                                        editorHtml:
                                                                            "Erro ao carregar template.",
                                                                    }
                                                                );
                                                            });
                                                    }
                                                    return setValue(
                                                        "HR_FIM",
                                                        horasTexto
                                                    );
                                                }}
                                            />
                                            <UnForm.Input
                                                name="HR_FIM"
                                                wrapperClassName="col-md-6 col-lg-4"
                                                label="Hora Final"
                                                type={"time"}
                                                registerOptions={{
                                                    required:
                                                        "Insira o Horário Final do Reparo",
                                                    validate: {
                                                        seHorarioFinalMaiorQueInicial:
                                                            () => {
                                                                const horasInicio =
                                                                    getValues(
                                                                        "HR_INICIO"
                                                                    ).split(
                                                                        ":"
                                                                    )[0];
                                                                const minutosInicio =
                                                                    getValues(
                                                                        "HR_INICIO"
                                                                    ).split(
                                                                        ":"
                                                                    )[1];

                                                                const horasFim =
                                                                    getValues(
                                                                        "HR_FIM"
                                                                    ).split(
                                                                        ":"
                                                                    )[0];
                                                                const minutosFim =
                                                                    getValues(
                                                                        "HR_FIM"
                                                                    ).split(
                                                                        ":"
                                                                    )[1];

                                                                const minutosTotalInicio =
                                                                    Number(
                                                                        minutosInicio
                                                                    ) +
                                                                    Number(
                                                                        horasInicio
                                                                    ) *
                                                                        60;

                                                                const minutosTotalFim =
                                                                    Number(
                                                                        minutosFim
                                                                    ) +
                                                                    Number(
                                                                        horasFim
                                                                    ) *
                                                                        60;

                                                                let validaHoras =
                                                                    minutosTotalFim -
                                                                    minutosTotalInicio;
                                                                if (
                                                                    idTemplateEmail !==
                                                                    0
                                                                ) {
                                                                    PreencherTemplateEmailClienteController(
                                                                        idTemplateEmail,
                                                                        {
                                                                            ...watcher,
                                                                            ID_USUARIO:
                                                                                watcher.ID_USUARIO,
                                                                            ID_CASO:
                                                                                ID_CASO
                                                                                    ? ID_CASO
                                                                                    : watcher.ID_CASO,
                                                                            HR_INICIO:
                                                                                watcher.HR_INICIO,
                                                                        }
                                                                    )
                                                                        .then(
                                                                            (
                                                                                res
                                                                            ) => {
                                                                                setConvertedText(
                                                                                    {
                                                                                        editorHtml:
                                                                                            res,
                                                                                    }
                                                                                );
                                                                            }
                                                                        )
                                                                        .catch(
                                                                            () => {
                                                                                setConvertedText(
                                                                                    {
                                                                                        editorHtml:
                                                                                            "Erro ao carregar template.",
                                                                                    }
                                                                                );
                                                                            }
                                                                        );
                                                                }
                                                                if (
                                                                    validaHoras >
                                                                    0
                                                                ) {
                                                                    return true;
                                                                } else {
                                                                    return "Horário Final Menor que Horário Inicial";
                                                                }
                                                            },
                                                    },
                                                }}
                                            />
                                        </>
                                    )}
                                    {!ID_CASO && (
                                        <UnForm.Input
                                            name="ID_CASO"
                                            wrapperClassName="col-md-6 col-lg-4"
                                            label="Protocolo"
                                            type={"number"}
                                            registerOptions={{
                                                required:
                                                    "Insira um protocolo de atendimento",
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="mb-8">
                                <label>Template de Email:</label>

                                <UnForm.Select
                                    className={`form-control placeholder-dark-50 `}
                                    name=""
                                    disabled={
                                        watcher.ID_USUARIO === ""
                                            ? true
                                            : watcher.HR_INICIO === ""
                                            ? true
                                            : watcher.DT_CADASTRO === ""
                                            ? true
                                            : false
                                    }
                                    onChange={(e) => {
                                        const idTemplateEmail = Number.parseInt(
                                            e.target.value
                                        );
                                        setIdTemplateEmail(idTemplateEmail);
                                        if (e && idTemplateEmail) {
                                            const docTemplate =
                                                LstDocumentoTemplate?.find(
                                                    (dt) =>
                                                        dt.ID_DOCUMENTO_TEMPLATE ===
                                                        idTemplateEmail
                                                );
                                            if (
                                                docTemplate &&
                                                docTemplate.DS_ASSUNTO
                                            )
                                                setValue(
                                                    "assunto",
                                                    docTemplate.DS_ASSUNTO
                                                );
                                            setConvertedText({
                                                editorHtml: "Carregando....",
                                            });
                                            PreencherTemplateEmailClienteController(
                                                idTemplateEmail,
                                                {
                                                    ...watcher,
                                                    ID_USUARIO:
                                                        watcher.ID_USUARIO,
                                                    ID_CASO: ID_CASO
                                                        ? ID_CASO
                                                        : watcher.ID_CASO,
                                                    HR_INICIO:
                                                        watcher.HR_INICIO,
                                                }
                                            )
                                                .then((res) => {
                                                    setConvertedText({
                                                        editorHtml: res,
                                                    });

                                                    setAssunto(
                                                        `${docTemplate?.DS_ASSUNTO} - ` +
                                                            `${
                                                                Atendimento?.DS_PRODUTO_COMP?.split(
                                                                    "-"
                                                                )[0]
                                                            } - ` +
                                                            `${Atendimento?.DS_PRODUTO}`
                                                    );
                                                })
                                                .catch(() => {
                                                    setConvertedText({
                                                        editorHtml:
                                                            "Erro ao carregar template.",
                                                    });
                                                });
                                        }
                                    }}
                                >
                                    <option>Modelo de email</option>
                                    {LstDocumentoTemplate &&
                                        LstDocumentoTemplate.map((doc) => {
                                            return (
                                                <option
                                                    key={
                                                        doc.ID_DOCUMENTO_TEMPLATE
                                                    }
                                                    value={
                                                        doc.ID_DOCUMENTO_TEMPLATE
                                                    }
                                                >
                                                    {doc.DS_DOCUMENTO}
                                                </option>
                                            );
                                        })}
                                </UnForm.Select>
                            </div>
                            <div className="mb-8">
                                <label>Assunto:</label>
                                <UnForm.Input
                                    type="text"
                                    name="DS_ASSUNTO"
                                    autoComplete="off"
                                    className={`form-control px-0 p-2 placeholder-muted-75`}
                                    value={assunto}
                                    registerOptions={{
                                        required: "Insira o Assunto do E-mail",
                                    }}
                                />
                            </div>
                            <div className="mb-8">
                                <div className=" w-100 h-100">
                                    <label>Descrição:</label>
                                    <FroalaEditor
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        value={convertedText.editorHtml || ""}
                                    />
                                </div>
                            </div>
                            <div className="mb-8">
                                <div className="row">
                                    <UnForm.Textarea
                                        name="DS_LOCAL"
                                        label="Local"
                                        noRezise
                                        rows={4}
                                        wrapperClassName="col-12 col-md-12 m-0"
                                        defaultValue={
                                            props.Atendimento?.DS_PRODUTO
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="row m-0 mb-2">
                                        <label className="col-md-3 ml-15">
                                            Vizinho
                                        </label>
                                        <UnForm.Switch
                                            color="success"
                                            name="NECESSIDADE_VIZINHO.FL_VIZINHO"
                                            type="checkbox"
                                            wrapperClassName="col-12 col-md-12 m-0"
                                            onChange={handleCheckboxChange}
                                        />
                                    </div>
                                </div>
                                {mostrarCampos === true ? (
                                    <>
                                        <div className="col-md-3">
                                            <div className="row m-0 ">
                                                <label className="col-md-2 ml-4">
                                                    Nome
                                                </label>
                                                <UnForm.Input
                                                    name="NECESSIDADE_VIZINHO.DS_NOME"
                                                    wrapperClassName="col-12 col-md-12 m-0"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="row m-0 ">
                                                <label className="col-md-2 ml-4">
                                                    Unidade
                                                </label>
                                                <UnForm.Input
                                                    name="NECESSIDADE_VIZINHO.DS_UNIDADE_VIZINHO"
                                                    wrapperClassName="col-12 col-md-12 m-0"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="row m-0 ">
                                                <label className="col-md-2 ml-4">
                                                    Telefone
                                                </label>
                                                <UnForm.Input
                                                    name="NECESSIDADE_VIZINHO.NR_TELEFONE_VIZINHO"
                                                    wrapperClassName="col-12 col-md-12 m-0"
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </div>

                            {id === 1 ? (
                                <button
                                    className="btn btn-primary d-flex align-items-center justify-content-center flex-nowrap g-2 w-100"
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent: "Verificar Agenda",
                                            IconHeader: faCalendar,
                                            Component: () => (
                                                <>
                                                    <AgendaModal />
                                                </>
                                            ),
                                            size: "xl",
                                        });
                                    }}
                                >
                                    <span>
                                        <FontAwesomeIcon icon={faCalendar} />
                                    </span>
                                    Verificar Agenda
                                </button>
                            ) : null}

                            <UnForm.SubmitButton
                                color="success"
                                wrapperClassName="w-100 mt-8"
                                className="w-100"
                                icon={faCalendar}
                                loading={loading}
                                disabled={loading}
                                loadingSize={"sm"}
                            >
                                Criar Agendamento
                            </UnForm.SubmitButton>
                        </>
                    )}
                </UnForm>
            </FormProvider>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
